import {
  Badge,
  KeyReferenceBar,
  KeyReferenceBarSection,
} from "@apex/component-library";
import { Box, Link, Text } from "@chakra-ui/react";

import { AccountData } from "../../api/useGetAccountDetails";
import { useGetCorrespondentSummary } from "../../api/useGetCorrespondentSummary";
import InlineError from "../InlineError";

interface AccountDetailsProps {
  accountId: string;
  accountData?: AccountData;
}

const AccountDetails = ({ accountId, accountData }: AccountDetailsProps) => {
  const { data: correspondentData, isError } =
    useGetCorrespondentSummary(accountId);

  const statusBadge = () => {
    if (!accountData) return;

    const { isActive, restrictionCode } = accountData;
    if (!isActive) {
      return <Badge colorScheme="red">Closed</Badge>;
    } else {
      if (restrictionCode) {
        return <Badge colorScheme="yellow">Restricted</Badge>;
      }
      return <Badge colorScheme="green">Open</Badge>;
    }
  };

  return (
    <>
      {accountData && (
        <>
          <Box mt={4} mb={2} data-testid="account-details">
            <Text fontWeight={"semibold"}>Account Details</Text>
          </Box>
          <KeyReferenceBar background="white" pl={0} pt={2}>
            <KeyReferenceBarSection title="Status">
              {statusBadge()}
            </KeyReferenceBarSection>
            <KeyReferenceBarSection title="Account ID">
              <Link
                href={`${window.location.origin}/accounts/#/${accountId}`}
                color="blue.400"
                data-testid="account-link"
                isExternal
              >
                {accountId.toUpperCase()}
              </Link>
            </KeyReferenceBarSection>
            <KeyReferenceBarSection title="Title">
              {accountData && accountData.accountTitle}
            </KeyReferenceBarSection>
            <KeyReferenceBarSection title="Funding Type">
              {accountData && accountData.accountType}
            </KeyReferenceBarSection>
            <KeyReferenceBarSection title="Correspondent">
              {isError ? (
                <InlineError />
              ) : (
                correspondentData && correspondentData.code
              )}
            </KeyReferenceBarSection>
          </KeyReferenceBar>
        </>
      )}
    </>
  );
};

export default AccountDetails;
